import React, { useCallback } from "react";
import styled from "styled-components";
import ReCAPTCHA from "react-google-recaptcha";
import { Row, Col, Form } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../constants/forms";
import { getFieldProps } from "../../../../utils/form-fields";
import { hexToRGBA } from "../../../../utils/theme";

import TextInput from "../../controls/TextInput";
import MaskInput from "../../controls/MaskInput";
import Textarea from "../../controls/Textarea";
import Switch from "../../controls/Switch";
import Button from "../../styled/Button";

const StyledContactUsForm = styled(Form)`
  padding: 16px;
  border: 1px solid ${hexToRGBA('#000000', 0.1)};

  .contact-block-title {
    margin-bottom: 1rem;
    padding-top: 10px;
    padding-bottom: 10px;

    font-family: 'InterRegular';
    color: #424242;

    span {
      font-family: 'InterSemiBold';
    }
  }

  button {
    width: 100%;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    .contact-block-title {
      margin-bottom: 0;
    }
  }
`;

// eslint-disable-next-line react/display-name
const ContactUsForm = React.forwardRef(({ values = {}, onReCaptcha, onChange, onSubmit }, ref) => {
  const showOrderId = values[FORM_FIELD_KEYS.questionsOrder] === "true";
  const captchaSiteKey = process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_PUBLIC_KEY;

  const handleSubmitButtonMouseDown = useCallback(() => {
    onChange && onChange({ target: { id: "suspendedSubmit", value: true } });
  }, [onChange]);

  return (
    <StyledContactUsForm
      noValidate
      validated={values.validated}
      onSubmit={onSubmit}
    >
      <Row>
        <Col xs={12}>
          <div className="contact-block-title">
            Use the form below to submit a support request. 
            A business filing expert will be in touch with you as soon as possible.&nbsp;
            <span>If submitted after office hours, we will respond on the next business day.</span>
          </div>
        </Col>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.customerFirstName)}
            value={values[FORM_FIELD_KEYS.customerFirstName]}
            onChange={onChange}
            column
          />
        </Col>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.customerLastName)}
            value={values[FORM_FIELD_KEYS.customerLastName]}
            onChange={onChange}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <MaskInput
            {...getFieldProps(FORM_FIELD_KEYS.customerPhone)}
            value={values[FORM_FIELD_KEYS.customerPhone]}
            onChange={onChange}
          />
        </Col>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.customerEmail)}
            loading={values.verifying}
            value={values[FORM_FIELD_KEYS.customerEmail]}
            onChange={onChange}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Switch
            {...getFieldProps(FORM_FIELD_KEYS.questionsOrder)}
            value={values[FORM_FIELD_KEYS.questionsOrder]}
            onChange={onChange}
          />
        </Col>
      </Row>
      {showOrderId && (
        <Row>
          <Col xs={12}>
            <TextInput
              {...getFieldProps(FORM_FIELD_KEYS.orderId)}
              value={values[FORM_FIELD_KEYS.orderId]}
              onChange={onChange}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col xs={12}>
          <Textarea
            {...getFieldProps(FORM_FIELD_KEYS.message)}
            validated={values.validated}
            value={values[FORM_FIELD_KEYS.message]}
            onChange={onChange}
          />
        </Col>
      </Row>
      {captchaSiteKey && (
        <Row>
          <Col xs={12}>
            <ReCAPTCHA
              className="g-recaptcha"
              ref={ref}
              sitekey={captchaSiteKey}
              onChange={onReCaptcha}
            />
          </Col>
        </Row>
      )} 
      <Row>
        <Col xs={0} md={3} />
        <Col xs={12} md={6}>
          <Button
            type="submit"
            id="ContactUsSubmitButton"
            onMouseDown={handleSubmitButtonMouseDown}
            // disabled={!ref?.current?.getValue()}
          >
            Submit
          </Button>
        </Col>
        <Col xs={0} md={3} />
      </Row>
    </StyledContactUsForm>
  );
});

export default ContactUsForm;
